import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PredefinedMesgStore {
  loading = false;
  total = 0;
  messageList = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      messageList: observable,

      loadData: action,
      deleteRecord: action,

      addData: action,
      getMessageData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, page }) {
    this.loading = true;
    var postData = {
      offset: offset,
      limit: limit,
      page: page,
    };

    //   var response = await postApi
    //     .getClient()
    //     .post(
    //       "index.php?c=predefinedMessage&a=predefinedMessageList",
    //       "postData=" + base64Input
    //     );

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/predefinedMessageList/getpredefinedMessageList", {
        params: postData,
      });

    this.messageList = response?.data?.data?.MessageData;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(messageData) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "/predefinedMessageList/createOrUpdatePredefinedMessage",
        messageData
      );
    return response.data;
  }

  async getMessageData(id) {
    var postData = {
      id: id,
      limit: 1,
      offset: 0,
    };

    //   var response = await postApi
    //     .getClient()
    //     .post(
    //       "index.php?c=predefinedMessage&a=predefinedMessageList",
    //       "postData=" + base64Input
    //     );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/predefinedMessageList/getpredefinedMessageList", {
        params: postData,
      });

    return response?.data?.data?.MessageData[0];
  }

  async deleteRecord({ id }) {
    //   var response = await postApi
    //     .getClient()
    //     .post(
    //       "index.php?c=predefinedMessage&a=delete",
    //       "postData=" + base64Input
    //     );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete(`/predefinedMessageList/deletePredefinedMessage/${id}`);

    return response;
  }
}
export default PredefinedMesgStore;
